var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsLeftmouse(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.607,
    height: 169.1786,
    viewBox: "0 0 130.607 169.1786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 62.0681,
    y: 16.282,
    width: 9.2144,
    height: 20.3333,
    fill: "#d3343f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.9383 16.282 55.9123 16.282 66.6753 0 77.9383 16.282",
    fill: "#d3343f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 62.3181,
    y: 132.5633,
    width: 9.2144,
    height: 20.3333,
    transform: "translate(133.8507 285.4599) rotate(-180)",
    fill: "#d3343f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.6623 152.8966 77.6883 152.8966 66.9253 169.1786 55.6623 152.8966",
    fill: "#d3343f"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.9002,
    y: 73.9779,
    width: 9.2144,
    height: 20.3333,
    transform: "translate(-56.6372 111.6521) rotate(-90)",
    fill: "#d3343f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.3408 72.8816 17.3408 94.9076 1.0588 84.1446 17.3408 72.8816",
    fill: "#d3343f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 101.0915,
    y: 73.7279,
    width: 9.2144,
    height: 20.3333,
    transform: "translate(189.5933 -21.8041) rotate(90)",
    fill: "#d3343f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.8653 95.1576 115.8653 73.1316 132.1473 83.8946 115.8653 95.1576",
    fill: "#d3343f"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.6741,64.6021c0-16.0859,13.0402-29.1262,29.1262-29.1262h0v39.1262h-29.1262v-10Z",
    fill: "#d3343f"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.8004,
    y1: 35.4759,
    x2: 66.8004,
    y2: 74.6021,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.6741,
    y: 35.4759,
    width: 58.2524,
    height: 97.0874,
    rx: 29.1262,
    ry: 29.1262,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLeftmouse);
export default __webpack_public_path__ + "static/media/icons_leftmouse.f151d6cdc9fe5aee9322edc08ae3bfd0.svg";
export { ForwardRef as ReactComponent };